<template>
  <div id="statusPreliminaryBokkingModel" class="modal fade" style="pointer-events: none;">
    <div class="modal-dialog modal-confirm_1">
      <div class="modal-content">

        <div class="modal-header flex-column">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
        </div>

        <div class="modal-body">
          <p>
            {{ statusData.response  }}
          </p>
          <p >
            {{ statusData.additional_information }}
          </p>
        </div>
        <div class="modal-footer justify-content-center">
          <button id="closemoda" type="button" @click="close()" class="btn btn-secondary c-bbtn" data-dismiss="modal">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmModal",
  props: {
    statusData: {
      type: [String, Object,Array],
    },
  },
  data() {
    return {};
  },
  computed: {
    lan() {
      return this.$store.getters.whichLanguage;
    },
  },
  methods: {
    close() {
      document.getElementById('closemodal').click();
    },
    deletef() {
      document.getElementById('closemodal').click();
      this.$router.push("/login");
    },
  },
};
</script>
<style >
.modal-confirm_1 {
  color: #636363;
  width: 400px;
}
.modal-confirm_1 .modal-content {
  padding: 20px;
  border-radius: 5px;
  border: none;
  text-align: center;
  font-size: 14px;
}
.modal-confirm_1 .modal-header {
  border-bottom: none;
  position: relative;
}
.modal-confirm_1 h4 {
  text-align: center;
  font-size: 26px;
  margin: 30px 0 -10px;
}
.modal-confirm_1 .close {
  position: absolute;
  top: -5px;
  right: -2px;
}
.modal-confirm_1 .modal-body {
  color: #999;
}
.modal-confirm_1 .modal-footer {
  border: none;
  text-align: center;
  border-radius: 5px;
  font-size: 13px;
  padding: 10px 15px 25px;
}
.modal-confirm_1 .modal-footer a {
  color: #999;
}
.modal-confirm_1 .icon-box {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  z-index: 9;
  text-align: center;
  border: 3px solid #f15e5e;
}
.modal-confirm_1 .icon-box i {
  color: #f15e5e;
  font-size: 46px;
  display: inline-block;
  margin-top: 13px;
}
.modal-confirm_1 .btn,
.modal-confirm_1 .btn:active {
  color: #fff;
  border-radius: 4px;
  background: #60c7c1;
  text-decoration: none;
  transition: all 0.4s;
  line-height: normal;
  min-width: 160px;
  font-size: 12px;
  border: none;
  min-height: 40px;
  border-radius: 3px;
  margin: 0 5px;
}
.modal-confirm_1 .c-bbtn {
  background: #c1c1c1;
  height: 70px;
}
.modal-confirm_1 .c-bbtn:hover,
.modal-confirm_1 .c-bbtn:focus {
  background: #a8a8a8;
}
.modal-confirm_1 .dan-btn {
  background: #f15e5e;
  height: 70px;
}
.modal-confirm_1 .dan-btn:hover,
.modal-confirm_1 .dan-btn:focus {
  background: #ee3535;
}
</style>
